import React, { useEffect, useState } from "react";
import withStyles from "@mui/styles/withStyles";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Button, Typography } from "@mui/material";
import { useDropzone } from "react-dropzone";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import axios from "axios";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";

const styles = (theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    maxWidth: "1000px",
  },

  dropzone: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: "2px",
    borderRadius: "2px",
    borderColor: theme.palette.primary.main,
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
    textAlign: "center",
    "& p": {
      margin: theme.spacing(0.5),
    },
  },

  btnContainer: {
    display: "flex",
    flexDirection: "row-reverse",
    justifyContent: "end",
    gap: "1rem",
    alignItems: "center",
  },

  fileNameContainer: {
    display: "flex",
    flexDirection: "column",
    "& ul": {
      margin: 0,
      padding: theme.spacing(0, 1),
    },

    "& h4": {
      margin: theme.spacing(2, 0),
    },
  },

  titleField: {
    padding: "1rem",
    border: "1px solid #ccc",
    width: "100%",
    background: "transparent",
  },

  postImg: {
    height: "220px",
    width: "100%",
    aspectRatio: "16/9",
    objectFit: "cover",
    borderRadius: "8px",
  },

  profileContainer: {
    display: "flex",
    gap: "1rem",
    alignItems: "center",
    "& img": {
      width: "55px",
      height: "55px",
      borderRadius: "50%",
    },
  },
});

const Create = ({ classes, userLoggedIn }) => {
  const [editorValue, setEditorValue] = useState("");
  const [title, setTitle] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const history = useHistory();
  const location = useLocation();
  const [preview, setPreview] = useState(
    location.state?.edit && location.state?.post.imageURL
  );

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    maxFiles: 1,
    accept: {
      "image/*": [],
    },
  });

  const acceptedFileItems = acceptedFiles.map((file) => {
    return (
      <li key={file.path}>
        {file.path} - {file.size} bytes
      </li>
    );
  });

  useEffect(() => {
    if (acceptedFiles.length > 0) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(acceptedFiles[0]);
    }
  }, [acceptedFiles]);

  //post data
  const handleCreatePost = async () => {
    if (!acceptedFiles.length) {
      try {
        let request = {
          title: title,
          content: editorValue,
        };
        if (location.state?.edit) {
          await axios.put(
            `/api/socials/posts/update/${location.state.post.slug}`,
            request
          );
        } else {
          await axios.post("/api/socials/posts/create", request);
        }
        history.push({
          pathname: "/community",
          state: { created: true },
        });
      } catch (error) {
        console.error("An error occurred:", error);
      }
    } else {
      let formData = new FormData();
      let fileName = `${title}.${"jpg"}`;
      let file = new File([acceptedFiles[0]], fileName);

      formData.append("file", file);
      // formData.append("upload_preset", "aue92bwk");
      //
      // var instance = axios.create();
      // delete instance.defaults.headers.common["Authorization"];

      axios
        .post("/api/users/upload-image", formData)
        .then((response) => {
          let request = {
            title: title,
            content: editorValue,
            imageURL: response.data.secure_url,
          };
          if (location.state?.edit) {
            return axios.put(
              `/api/socials/posts/update/${location.state.post.slug}`,
              request
            );
          } else {
            return axios.post("/api/socials/posts/create", request);
          }
        })
        .then(() => {
          history.push({
            pathname: "/community",
            state: { created: true },
          });
        })
        .catch((error) => {
          console.error("An error occurred:", error);
        });
    }
  };

  useEffect(() => {
    if (location.state?.edit) {
      setTitle(location.state.post.title);
      setEditorValue(location.state.post.content);
    }
  }, []);

  return (
    <div
      className={classes.wrapper}
      style={{ margin: location.state?.edit ? "10rem auto" : "auto" }}
    >
      <div className={classes.profileContainer}>
        <svg
          version="1.1"
          id="Vrstva_1"
          x="0px"
          y="0px"
          viewBox="0 0 100 100"
          width={55}
          height={55}
        >
          <g>
            <path d="M11.4,93.3c-0.1,0-0.1,0-0.2,0c-1.3-0.1-2.2-1.2-2.1-2.4c1.3-19.1,19.3-34,40.9-34c21.6,0,39.6,14.9,40.9,33.9   c0.1,1.3-0.9,2.3-2.1,2.4c-1.3,0.1-2.3-0.9-2.4-2.1C85.2,74.4,69.2,61.4,50,61.4c-19.3,0-35.3,13.1-36.4,29.8   C13.5,92.4,12.5,93.3,11.4,93.3z" />
            <path d="M50,52.3c-12.6,0-22.8-10.2-22.8-22.8S37.4,6.7,50,6.7c12.6,0,22.8,10.2,22.8,22.8S62.6,52.3,50,52.3z M50,11.3   c-10,0-18.2,8.2-18.2,18.2S40,47.7,50,47.7c10,0,18.2-8.2,18.2-18.2S60,11.3,50,11.3z" />
          </g>
        </svg>

        <div>
          <Typography variant="h6">{userLoggedIn.name}</Typography>
          <Typography variant="subtitle1" fontSize={12}>
            Post to Anyone
          </Typography>
        </div>
      </div>
      <div className={classes.btnContainer}>
        <Button
          variant="outlined"
          color="primary"
          disableElevation
          onClick={handleOpen}
          sx={{ borderWidth: "2px" }}
        >
          {acceptedFiles[0]?.path || location.state?.post.imageURL
            ? "Change Image"
            : "Add Image"}
        </Button>
        <span>{acceptedFiles[0]?.path}</span>
      </div>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "background.paper",
              border: "none",
              borderRadius: "8px",
              boxShadow: 24,
              p: 4,
            }}
          >
            <div {...getRootProps({ className: classes.dropzone })}>
              <input {...getInputProps()} />
              <p>Drag and drop the image you want to upload</p>
              <p>OR</p>
              <p>Click to browse</p>
            </div>
            <aside className={classes.fileNameContainer}>
              <h4>File name: </h4>
              <ul>{acceptedFiles[0]?.path}</ul>
              <Button
                disabled={acceptedFiles.length === 0}
                onClick={() => handleClose()}
                variant="contained"
                sx={{ alignSelf: "end" }}
              >
                Add Image
              </Button>
            </aside>
          </Box>
        </Fade>
      </Modal>

      {preview && (
        <img src={preview} alt="preview" className={classes.postImg} />
      )}
      <input
        type="text"
        name="title"
        placeholder="Enter Post title"
        className={classes.titleField}
        onChange={(e) => setTitle(e.target.value)}
        value={title}
      />
      <ReactQuill theme="snow" value={editorValue} onChange={setEditorValue} />
      <Button
        onClick={() => handleCreatePost()}
        variant="contained"
        color="primary"
        disableElevation
      >
        Create Post
      </Button>
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(Create);
